import { defineStore, storeToRefs } from "pinia";
import { createConditionsGroup } from "@stores/survey/cardPayloadHandler";
import { useCurrentCardStore } from "@stores/survey/currentCard/currentCard";
import { useConditionsStore } from "@stores/survey/conditions/conditions";

export const useConditionsGroupsStore = defineStore("conditionsGroups", () => {
  const { currentCard } = storeToRefs(useCurrentCardStore());

  const updateConditionsGroupOperator = (conditionsGroups, { index, value }) =>
    (conditionsGroups[index].group_operator = value);

  const handleAddConditionsGroup = (conditionsGroups) => {
    if (conditionsGroups.length === 0) {
      currentCard.value.specs.conditions = conditionsGroups;
    }
    addConditionsGroup(conditionsGroups);
  };
  const addConditionsGroup = (conditionsGroups) => {
    const group = createConditionsGroup();
    group.group_conditions[0].card_token = useConditionsStore().nearestCardToken();
    conditionsGroups.push(group);
  };
  const removeConditionsGroup = (conditionsGroups, index) => conditionsGroups.splice(index, 1);

  return {
    updateConditionsGroupOperator,
    handleAddConditionsGroup,
    addConditionsGroup,
    removeConditionsGroup,
  };
});
